module.exports = __webpack_public_path__ + "static/media/Detsky_krem_na_opruzeniny_Omega369_retina.044b715c.jpg";